export const name = 'gzUniqueValidator';
export default function gzUniqueValidator($q) {
  'ngInject';

  let directive = {
    require: 'ngModel',
    restrict: 'A',
    scope: {
      gzUniqueValidator: '=',
      gzUniqueValidatorProperty: '@',
      gzUniqueValidatorMatchCase: '@?'
    },
    link: gzUniqueValidatorLink
  };

  return directive;

  /////////////////

  function gzUniqueValidatorLink(scope, element, attrs, ctrl) {
    ctrl.$asyncValidators.gzUniqueValidator = (modelValue, viewValue) => {

      // If nothing has been entered it's unique
      if (ctrl.$isEmpty(modelValue)) {
        return $q.resolve();
      }

      let collection = scope.gzUniqueValidator;
      let property = scope.gzUniqueValidatorProperty;
      let matchCase = true;

      // If there is no collection or property
      if (!collection || !property) {
        return $q.resolve();
      }

      if (scope.gzUniqueValidatorMatchCase) {
        matchCase = scope.gzUniqueValidatorMatchCase.toLocaleLowerCase() === 'false' ? false : true;
      }

      if (_.find(collection, (item) => {
          if (matchCase) {
            return (item[property] === modelValue);
          }
          else {
            return (item[property].toLocaleLowerCase() === modelValue.toLowerCase());
          }
        })) {
        return $q.reject();
      }
      else {
        return $q.resolve();
      }
    };
  }

}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/uniqueValidator.directive.js